import { FC } from 'react';

const BigDialogTerms: FC = () => {
  return <div></div>;
};

export default BigDialogTerms;
